import { App } from '@capacitor/app'
import { ref } from 'vue'
import { useGlobalStateStore } from '@/store/globalState'

export function useBgm() {
  const bgm = ref()
  const bgmUrl = ref('')
  const error = ref()
  const isPageActive = ref(true)
  const isManuallyPaused = ref(false)

  const globalStore = useGlobalStateStore()

  App.addListener('appStateChange', (state) => {
    if (state.isActive && isPageActive.value && !isManuallyPaused.value) {
      resumeBgm()
    }
    else {
      stopBgm()
    }
  })

  function setPageActive(active: boolean) {
    isPageActive.value = active
  }

  function playBgm(url: string | undefined) {
    if (!url) {
      if (bgm.value) {
        bgm.value.pause()
      }
      bgmUrl.value = ''
      return
    }

    if (bgm.value) {
      bgm.value.pause()
      bgm.value.currentTime = 0
    }
    try {
      bgmUrl.value = url
      bgm.value = new Audio(url)
      bgm.value.id = 'bgm'
      if (globalStore.canAutoplayMedia) {
        bgm.value.volume = 0.3
        bgm.value.play()
      }
      else {
        bgm.value.mute = true
      }
      bgm.value.loop = true
    }
    catch (err) {
      error.value = err
    }
  }

  function stopBgm(isManual: boolean = false) {
    if (bgm.value) {
      bgm.value.pause()
      isManuallyPaused.value = isManual
    }
  }

  function resumeBgm() {
    if (bgm.value) {
      bgm.value.play()
      isManuallyPaused.value = false
    }
  }

  /**
   * Avoid this issue
   * Uncaught (in promise) DOMException: play() failed because the user didn't interact with the document first. https://goo.gl/xX8pDD
   */
  function playBgmByTap() {
    if (error.value) {
      return
    }
    if (bgm.value) {
      bgm.value.mute = false
      bgm.value.volume = 0.3
      bgm.value.play()
    }
  }

  return {
    bgmUrl,
    error,
    setPageActive,
    playBgm,
    stopBgm,
    resumeBgm,
    playBgmByTap,
  }
}
